import timeutils from 'utils/wt-time-utils'
import { signStatus, workflowHallStatus, reportReadStatus, purchaseIntentionMode } from 'json/sign.js'
import { identityCardType } from 'json/sign'
import { sexArr } from 'json/customer-options'
import { getEnumeration } from 'enumeration'
import { cashCount } from '@/utils/formUtils'
export default {
  getSignList (data) {
    data.forEach(item => {
      item.start_time = item.startTime && timeutils.format(item.startTime, 'date')
      item.end_time = item.endTime && timeutils.format(item.endTime, 'date')
    })
    return data
  },
  getSignNotes (data) {
    data.forEach(item => {
      let genericFormData = (item.genericFormData && item.genericFormData.data) || {}
      item.sign_status = item.status && getEnumeration(item.status, signStatus)
      if (item.status === 'SUCCESS') {
        if (item.eventType === 'QUESTIONNAIRE') {
          item.sign_status = '已提交'
        } else {
          if (item.workflowStatus) {
            switch (item.activityCode) {
              case 'LIFE_EXPERIENCE_HALL':
                item.sign_status = item.workflowStatus && getEnumeration(item.workflowStatus, workflowHallStatus)
                break
              case 'TWENTIETH_ANNIVERSARY_ACT':
                item.sign_status = item.workflowStatus && getEnumeration(item.workflowStatus, workflowHallStatus)
                break
              case 'REPORT_INTERPRET':
                item.sign_status = item.workflowStatus && getEnumeration(item.workflowStatus, reportReadStatus)
                break
              default:
                item.sign_status = item.status && getEnumeration(item.status, signStatus)
                break
            }
          }
        }
      }
      item.unscramble_date = item.unscrambleDate && timeutils.format(item.unscrambleDate)
      item.parse_date = genericFormData.parseDate && timeutils.format(genericFormData.parseDate, 'date')
      item.registration_time = item.registrationTime && timeutils.format(item.registrationTime)
      item.promotion_amount = (item.userOption && item.userOption.deposit && (cashCount(item.userOption.deposit, true, 2))) || '--'
      item.identityCard_type = genericFormData.cardType && getEnumeration(genericFormData.cardType, identityCardType)
      // 处理20周年活动数据的字段
      item.time = genericFormData.time && timeutils.format(genericFormData.time, 'month')
      item.sign_in_time = item.signInTime && timeutils.format(item.signInTime)
      // 重购意向字段的处理
      item.gender = (genericFormData.gender && getEnumeration(genericFormData.gender, sexArr))
      item.repurchase_intention = (item.repurchaseIntention && getEnumeration(item.repurchaseIntention, purchaseIntentionMode)) || ''
      item.unscramble_date = item.unscrambleDate && timeutils.format(item.unscrambleDate)
      item.reportInterpret_time = item.reportInterpretTime && timeutils.format(item.reportInterpretTime)
      item.date_of_childbirth = genericFormData.expectedDate && timeutils.format(genericFormData.expectedDate, 'date')
      item.parse_date = genericFormData.parseDate && timeutils.format(genericFormData.parseDate, 'date')
      item.hospitalName = genericFormData.hospital
      item.address_show = null
      if (genericFormData && genericFormData.city && genericFormData.city.length) {
        genericFormData.city.forEach(etem => {
          genericFormData.city_show =
        genericFormData.city_show ? (genericFormData.city_show + etem.text) : etem.text
        })
      }
      if (genericFormData.address && genericFormData.address.length) {
        genericFormData.address.forEach(etem => {
          item.address_show = item.address_show ? (item.address_show + etem.text) : etem.text
        })
      }
    })
    return data
  },
  signNotesDetail (data) {
    data.sign_status = data.status && getEnumeration(data.status, signStatus)
    if (data.status === 'SUCCESS') {
      if (data.eventType === 'QUESTIONNAIRE') {
        data.sign_status = '已提交'
      } else {
        if (data.workflowStatus) {
          switch (data.activityCode) {
            case 'LIFE_EXPERIENCE_HALL':
              data.sign_status = getEnumeration(data.workflowStatus, workflowHallStatus)
              break
            case 'TWENTIETH_ANNIVERSARY_ACT':
              data.sign_status = getEnumeration(data.workflowStatus, workflowHallStatus)
              break
            case 'REPORT_INTERPRET':
              data.sign_status = getEnumeration(data.workflowStatus, reportReadStatus)
              break
            default:
              data.sign_status = data.status && getEnumeration(data.status, signStatus)
              break
          }
        }
      }
    }

    // data.sign_status = data.eventType === 'QUESTIONNAIRE' && data.status === 'SUCCESS' ? '已提交' : (data.status && getEnumeration(data.status, signStatus))
    data.registration_time = data.registrationTime && timeutils.format(data.registrationTime)
    data.cancel_time = data.operationalInformation && data.operationalInformation.time && timeutils.format(data.operationalInformation.time)
    data.promotion_amount = (data.userOption && data.userOption.deposit && (cashCount(data.userOption.deposit, true))) || '--'
    // 重购意向字段的处理
    data.repurchase_intention = (data.repurchaseIntention && getEnumeration(data.repurchaseIntention, purchaseIntentionMode)) || ''
    data.unscrambleDetail = data.unscrambleDetail || {}
    data.unscrambleDetail.unscrambleDate = data.unscrambleDetail.unscrambleDate && timeutils.format(data.unscrambleDetail.unscrambleDate)
    data.additionalUnscrambleDetail = data.additionalUnscrambleDetail || []
    data.unscramble_date = data.unscrambleDate && timeutils.format(data.unscrambleDate)
    // 处理用于展示解读详情的数组
    let readDetailData = []
    if (data.unscrambleDetail.userLogin) {
      data.unscrambleDetail.hasOperation = data.workflowStatus === 'CONFIRMED'
      readDetailData.push(data.unscrambleDetail)
    }
    data.additionalUnscrambleDetail.forEach(item => {
      item.hasOperation = true
      item.unscrambleDate = timeutils.format(item.unscrambleDate)
    })
    readDetailData = readDetailData.concat(data.additionalUnscrambleDetail)
    data.readDetailData = readDetailData
    return data
  }
}
